namespace $.$$ {

	class Method_line extends $mol_text_code_line {
		minimal_height(): number {
			return 0
		}
	}

	export class $shm_hitalama_map_widget_float_method extends $.$shm_hitalama_map_widget_float_method {

		@ $mol_memo.field
		get $() {
			return super.$.$mol_ambient({
				$mol_text_code_line: Method_line,
			})
		}

		head_view() {
			return [ this.Widget_head() ]
		}

		@ $mol_mem
		title_editing( next?: boolean ) {
			return next ?? false
		}

		method_title_sub() {
			return this.title_editing()
				? this.method_title_edit_sub()
				: super.method_title_sub()
		}

		@ $mol_action
		title_edit() {
			this.title_draft( this.title() )
			this.title_editing( true )
			new this.$.$mol_after_frame( ()=> this.title_select() )
		}

		@ $mol_action
		title_select() {
			const input = this.Title_input()
			input.focused( true )
			input.selection([ 0, this.title_draft().length ])
		}

		@ $mol_action
		title_apply() {
			this.title( this.title_draft().trim() || this.title() )
			this.title_editing( false )
		}

		@ $mol_action
		title_cancel() {
			this.title_draft( this.title() )
			this.title_editing( false )
		}

		@ $mol_mem
		title( next?: string ): string {
			if( next === undefined ) return super.title()

			const prev = super.title()
			const value = this.widget().title( next )
			this.map().method_runtime().method_rename( prev, value )
			return value
		}

		@ $mol_mem
		code( next?: string ): string {
			return this.widget().code( next ) ?? ''
		}

		decorator( next?: string ): string {
			const data = this.widget().data() ?? {}
			if( next === undefined ) return this.$.$shm_hitalama_map_method_decorator( data.decorator )

			this.widget().data({
				... data,
				decorator: this.$.$shm_hitalama_map_method_decorator( next ),
			})
			return next
		}

		widget_method_click( id: string, event?: MouseEvent ) {
			const widget = this.map().method_runtime().method_widget_by_name( id )
			if( !widget ) return event ?? null

			this.Map_page().go_to_widget( widget.link() )
			this.Map_page().selected( widget.link(), true )

			return event ?? null
		}

	}

}
